import { useCallback, useEffect, useState } from 'react';
import type { InterestId } from '@/lib/interests';

const KEY = 'carvoeiro-nav-interests';

function read(): InterestId[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(parsed) ? parsed.filter((x): x is InterestId => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function useInterests() {
  const [ids, setIds] = useState<InterestId[]>(() => (typeof localStorage === 'undefined' ? [] : read()));

  useEffect(() => {
    setIds(read());
  }, []);

  const persist = useCallback((next: InterestId[]) => {
    setIds(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  }, []);

  const hasInterest = useCallback((id: InterestId) => ids.includes(id), [ids]);

  const toggleInterest = useCallback(
    (id: InterestId) => {
      persist(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
    },
    [ids, persist],
  );

  return { interestIds: ids, hasInterest, toggleInterest };
}
